import {useFormik} from 'formik'
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useSearchParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import {DEFAULT_PAGE} from '../../../../_gori/constants'
import {fileHelper} from '../../../../_gori/helpers'
import {BatchUploadMappingModal} from '../../batches'
import {BatchesConfig} from '../core/_const'

type Props = {
  reloadTable?: any
  initialFile?: File | null
  onClose?: () => void
}

const BatchesUpload: React.FC<Props> = ({reloadTable, initialFile, onClose}) => {
  const intl = useIntl()
  const [searchParams, setSearchParams] = useSearchParams()
  const [show, setShow] = useState<{upload: boolean; errors: boolean}>({
    upload: false,
    errors: false,
  })

  const handleUploadSuccess = () => {
    if (!(searchParams.get('search_text') === '' && searchParams.get('page') === DEFAULT_PAGE)) {
      searchParams.delete('search_text')
      searchParams.set('page', DEFAULT_PAGE)
      setSearchParams(searchParams, {replace: true})
    }
    reloadTable?.()
    formik.resetForm()
  }

  const handleCloseModal = () => {
    setShow((prev) => ({...prev, upload: false}))
    formik.resetForm()
    onClose?.()
  }

  const processFile = async (file: File) => {
    if (!file) return

    if (BatchesConfig.SUPPORTED_FORMATS.indexOf(file.type) > -1) {
      formik.setFieldValue('fileUpload', file)
      formik.submitForm()
    } else {
      toast.error(
        intl.formatMessage({
          id: 'INVALID_FILE_TYPE_CSV_ONLY',
        })
      )
      onClose?.()
    }
  }

  const formik = useFormik({
    initialValues: {
      fileUpload: null,
      columnsCSV: null,
    },
    onSubmit: async (values: any) => {
      const {row, header} = await fileHelper.checkRowHaveData(values.fileUpload)
      if (row <= BatchesConfig.MAX_UPLOAD) {
        const columnsCSV = fileHelper.convertHeaderFile(header)
        await formik.setFieldValue('columnsCSV', columnsCSV)
        await setShow((prev) => ({...prev, upload: true}))
      } else {
        toast.error(
          intl.formatMessage(
            {
              id: 'CANNOT_UPLOAD_MORE_THAN_INPUT_ITEMS',
            },
            {input: BatchesConfig.MAX_UPLOAD}
          )
        )
        onClose?.()
      }
    },
  })

  useEffect(() => {
    if (initialFile) {
      processFile(initialFile)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialFile])

  return (
    <>
      {show.upload && (
        <BatchUploadMappingModal
          showModal={show.upload}
          handleClose={handleCloseModal}
          data={formik.values}
          handleUploadSuccess={handleUploadSuccess}
        />
      )}
    </>
  )
}

export {BatchesUpload}
